'use client';

import { imageGallery, modalImage } from '@mage-ui/styled-system/recipes';
import { useContext, useState } from 'react';
import { StaticTextContext } from '@/components/context/StaticTextProvider';
import { CaptionWrapper } from '@/components/ui/data-display/caption-wrapper/CaptionWrapper';
import { ImageGallery } from '@/components/ui/images/image-gallery/ImageGallery';
import { Modal } from '@/components/ui/overlays/modal/Modal';

export const ModalImage = ({ children, src, alt, zoomEnabled }) => {
	const [opened, setOpened] = useState(false);
	const { st } = useContext(StaticTextContext);

	if (!zoomEnabled) return children;

	const classes = modalImage();

	return (
		<>
			<CaptionWrapper
				onClick={() => setOpened(true)}
				classNames={{ content: classes.content, icon: classes.icon }}
			>
				{children}
			</CaptionWrapper>
			<Modal
				opened={opened}
				onClose={() => setOpened(false)}
				texts={{ close: st('header.close') }}
			>
				<ImageGallery
					src={src}
					alt={alt}
					className={imageGallery({ shape: 'fill' })}
				/>
			</Modal>
		</>
	);
};
